import React, {  } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { MedicalCheckupType, MedicalCheckupTypeUtil } from '../../../models/enums/medicalCheckupType ';

interface MedicalCheckupTypesAutocompleteFormControlProps {
  name: string;
  label?: string;
  style?: React.CSSProperties;
  required?: boolean;
}

const MedicalCheckupTypesAutocompleteFormControl: React.FC<MedicalCheckupTypesAutocompleteFormControlProps> = ({ name, label = 'Тип осмотра', style, required }) => {
  const { control } = useFormContext();
  const types = Object.values(MedicalCheckupType);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? 'Обязательное поле' : false }}
      render={({ field, fieldState }) => (
        <Autocomplete
          multiple
          options={types}
          getOptionLabel={option => MedicalCheckupTypeUtil.getStringValue(option as MedicalCheckupType)}
          value={field.value}
          onChange={(_, value) => {
            field.onChange(value);
          }}
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              margin="dense"
              size="small"
              style={style}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              required={required}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          size="small"
        />
      )}
    />
  );
};

export default MedicalCheckupTypesAutocompleteFormControl; 